<template>
  <img :class="imageClass" :src="__src" :alt="alt" @error.once="setFallbackImg"/>
</template>

<script>
import { mapState } from 'vuex';
import { isPositiveNumber } from '../../../helpers/common';

const skinWhitelistByType = {
  achievement: [1, 2],
};

export default {
  name: 'BaseImage',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    fallbackSrc: {
      type: String,
      default: ''
    },
    imageClass: {
      type: [Object, Array, String],
      default: ''
    },
    typeForSkin: {
      type: String,
      default: '',
      validator: function (value) {
        return !value ||
          ['achievement'].includes(value);
      },
    }
  },
  computed: {
    ...mapState('common', [
      'duelSkin',
    ]),
    shouldUseSkin () {
      return this.typeForSkin &&
        isPositiveNumber(this.duelSkin, true) &&
        Array.isArray(skinWhitelistByType[this.typeForSkin]) &&
        skinWhitelistByType[this.typeForSkin].includes(this.duelSkin)
    },
    __src () {
      if (this.src && this.shouldUseSkin) {
        const prefix = this.src.startsWith('/') ? '/static' : 'static';

        return `${ prefix }/skins/skin_${ this.duelSkin }/${ this.src.substring(prefix.length + 1) }`;
      }

      return this.src || this.fallbackSrc;
    }
  },
  methods: {
    setFallbackImg (event) {
      if (this.fallbackSrc && (this.fallbackSrc !== event.target.src)) {
        event.target.src = this.fallbackSrc
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/image/BaseImage.vue